<!-- eslint-disable vue/no-v-html -->
<template>
  <BCard class="min-w-[100px]">
    <div class="mb-2">
      <div class="flex gap-[12px]">
        <BButton
          variant="primary"
          size="sm"
          class="rounded-[6px]"
          @click="goBack"
        >
          <img
            class="w-[20px]"
            src="https://storage.googleapis.com/komerce/assets/komerce-icon/Putih/arrow-left-2.svg"
            alt="arrow left"
          >
        </BButton>
        <div class="text-black font-semibold text-[24px]">
          Detail Riwayat Langganan -
          <span class="capitalize">{{ platform }}</span>
        </div>
      </div>
    </div>
    <div class="d-flex justify-content-end mb-2">
      <!-- Search Input for Google Platform -->
      <div
        v-if="isGooglePlatform"
        class="flex items-center !w-[300px] rounded-[8px] gap-[5px] px-[8px] border-[1px] border-[#E2E2E2] h-[40px]"
      >
        <span
          class="k-search-normal-1 font-bold align-middle text-[#828282]"
          style="font-size: 20px"
        />
        <BFormInput
          v-model="search"
          placeholder="Cari nama akun atau email"
          class="border-0 grow"
          @input="searchData"
        />
      </div>

      <!-- Date Range Picker for Other Platforms -->
      <BCol
        v-else
        md="3"
        class="mt-1 mt-md-0"
      >
        <DateRangePicker
          ref="picker"
          v-model="dateRange"
          :locale-data="locale"
          :ranges="ranges"
          :opens="'left'"
          class="w-100"
          style="min-width: 170px !important"
        >
          <template v-slot:input="picker">
            <div class="d-flex justify-content-between align-items-center mx-1">
              <span
                v-if="
                  picker.startDate === null && picker.endDate === null
                "
                style="color: #11263C !important; text-wrap: nowrap;"
              >
                Pilih Tanggal - Pilih Tanggal
              </span>
              <span
                v-else
                style="color: #11263C !important; text-wrap: nowrap;"
              >
                {{ DDMMMMYYYY(picker.startDate) }} -
                {{ DDMMMMYYYY(picker.endDate) }}
              </span>

              <img
                src="https://storage.googleapis.com/komerce/assets/icons/calendar.png"
                alt="Calendar"
                class="h-5 ml-1"
              >
            </div>
          </template>
        </DateRangePicker>
      </BCol>
    </div>

    <div class="border rounded-[8px] overflow-hidden">
      <BTable
        :items="subscriptionData"
        :fields="fields"
        :busy="loading.table"
        striped
        hover
        show-empty
        empty-text="Tidak ada data"
        @scroll="handleScroll"
      >
        <template #cell(no)="{ index }">
          {{ index + 1 }}
        </template>

        <!-- Google Platform: Nama Akun -->
        <template #cell(account_name)="{ item }">
          <div class="flex flex-col">
            <span class="text-[#333333]">{{ item.whitelist_account_name || '-' }}</span>
            <span class="text-[#828282] text-sm">{{ item.account_email || '-' }}</span>
          </div>
        </template>

        <!-- Google Platform: Waktu Pengajuan -->
        <template #cell(submission_time)="{ item }">
          <div
            v-if="item.created_at"
            class="flex flex-col"
          >
            <span class="text-[#333333]">{{ DDMMMMYYYY(item.created_at) }}</span>
            <span class="text-[#828282] text-sm">{{ TIME(item.created_at) }} WIB</span>
          </div>
          <span v-else>-</span>
        </template>

        <!-- Google Platform: Tanggal Sewa -->
        <template #cell(rental_date)="{ item }">
          <span
            v-if="item.expired_at"
            class="text-[#333333]"
          >{{ rentalDate(item) }}</span>
          <div
            v-else
            v-html="badgeProcessing()"
          />
        </template>

        <!-- Non-Google Platform: Tanggal Mulai Berlangganan -->
        <template #cell(start_date)="{ item }">
          {{ DDMMMMYYYY(item.created_at) }}
        </template>

        <!-- Tanggal Berakhir -->
        <template #cell(end_date)="{ item }">
          <template v-if="isGooglePlatform">
            <span
              v-if="item.expired_at"
              class="text-[#333333]"
            >{{ DDMMMMYYYY(item.expired_at) }}</span>
            <div
              v-else
              v-html="badgeProcessing()"
            />
          </template>
          <template v-else>
            {{ DDMMMMYYYY(item.expired_at) }}
          </template>
        </template>

        <!-- Durasi -->
        <template #cell(duration)="{ item }">
          <span :class="isGooglePlatform && 'text-[#333333]'">
            {{ item.duration_day ? `${item.duration_day} Hari` : '-' }}
          </span>
        </template>
      </BTable>
    </div>
  </BCard>
</template>

<script>
import {
  BCard, BCol, BButton, BTable, BFormInput,
} from 'bootstrap-vue'
import DateRangePicker from 'vue2-daterange-picker'
import 'vue2-daterange-picker/dist/vue2-daterange-picker.css'
import moment from 'moment'
import _ from 'lodash'
import { newAxiosIns } from '@/libs/axios'
import {
  firstDateOfMonth, today, yesterday, last7,
} from '@/store/helpers'
import {
  YEAR_MONTH_DAY,
  DDMMMMYYYY,
  TIME,
  LABELDAY,
  LABELMONTH,
} from '@/libs/filterDate'

export default {
  name: 'HistorySubscription',
  components: {
    BCard,
    BCol,
    BButton,
    BTable,
    BFormInput,
    DateRangePicker,
  },
  data() {
    return {
      YEAR_MONTH_DAY,
      DDMMMMYYYY,
      TIME,
      LABELDAY,
      LABELMONTH,
      search: null,
      dateRange: {
        startDate: undefined,
        endDate: undefined,
      },
      locale: {
        format: 'dd/mm/yyyy',
        daysOfWeek: LABELDAY,
        monthNames: LABELMONTH,
      },
      ranges: {
        'Hari ini': [today, today],
        Kemarin: [yesterday, yesterday],
        '7 Hari Terakhir': [last7, today],
        'Bulan ini': [firstDateOfMonth, today],
      },
      subscriptionData: [],
      loading: {
        table: false,
      },
      limit: 25,
      offset: 0,
      lastData: false,
    }
  },
  computed: {
    platform() {
      return this.$route.query.platform || 'meta'
    },
    isGooglePlatform() {
      return this.platform === 'google'
    },
    fields() {
      if (this.isGooglePlatform) {
        return [
          { key: 'no', label: 'No' },
          { key: 'account_name', label: 'Nama Akun' },
          { key: 'submission_time', label: 'Waktu Pengajuan' },
          { key: 'rental_date', label: 'Tanggal Sewa' },
          { key: 'end_date', label: 'Tanggal Berakhir' },
          { key: 'duration', label: 'Durasi Langganan' },
        ]
      }
      return [
        { key: 'no', label: 'No' },
        { key: 'start_date', label: 'Tanggal Mulai Berlangganan' },
        { key: 'end_date', label: 'Tanggal Berakhir' },
        { key: 'duration', label: 'Durasi' },
      ]
    },
  },
  watch: {
    dateRange() {
      if (!this.isGooglePlatform) {
        this.fetchData()
      }
    },
  },
  mounted() {
    this.getSubscriptionData()
  },
  methods: {
    badgeProcessing() {
      return `
        <div class="flex items-center justify-center gap-[.25rem] bg-[#F0F0F0] border border-[#E8E8E8] rounded-full py-[.25rem] px-[.75rem] w-fit">
          <span class="k-clock-1 !text-[#8D8D8D]"></span>
          <span class="!text-[#8D8D8D] text-sm">Diproses</span>
        </div>
      `
    },
    rentalDate(item) {
      if (item.expired_at && item.duration_day) {
        return this.DDMMMMYYYY(moment(item.expired_at).subtract(item.duration_day - 1, 'days'))
      }
      return '-'
    },
    goBack() {
      this.$router.push(
        `/komads/data-partner/${this.$route.params.id}/detail?platform=${this.platform}`,
      )
    },
    searchData: _.debounce(function search() {
      if (this.isGooglePlatform) {
        this.fetchData()
      }
    }, 500),
    /**
     * Get subscription data from API
     * @returns {Promise<void>}
     */
    async getSubscriptionData() {
      this.loading.table = true

      const params = {
        limit: this.limit,
        offset: this.offset,
        platform_name: this.platform,
        transaction_type: 'subscription',
        user_id: this.$route.params.id,
      }

      if (this.isGooglePlatform) {
        params.keyword = this.search
      } else {
        params.start_date = this.dateRange.startDate
          ? YEAR_MONTH_DAY(this.dateRange.startDate)
          : null
        params.end_date = this.dateRange.endDate
          ? YEAR_MONTH_DAY(this.dateRange.endDate)
          : null
      }

      try {
        const { data } = await newAxiosIns.get(
          'komads/api/v1/admin/whitelist_accounts/transactions',
          { params },
        )
        this.subscriptionData = data.data || []
        this.offset += data.data ? data.data.length : 0
        this.lastData = (data.data ? data.data.length : 0) < this.limit
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mengambil data subscription',
        })
        this.subscriptionData = []
      } finally {
        this.loading.table = false
      }
    },
    fetchData() {
      this.offset = 0
      this.lastData = false
      this.getSubscriptionData()
    },
    handleScroll(event) {
      const table = event.target || document.getElementById('table')
      if (
        table.scrollTop >= table.scrollHeight - table.offsetHeight - 20
        && !this.loading.table
        && !this.lastData
      ) {
        this.getNextSubscriptionData()
      }
      if (table.scrollTop === 0) {
        setTimeout(() => {
          table.scrollTop = 1
          setTimeout(() => {
            table.scrollTop = 0
          }, 10)
        }, 10)
      }
    },
    /**
     * Get next page of subscription data
     * @returns {Promise<void>}
     */
    async getNextSubscriptionData() {
      if (this.lastData || this.loading.table) return

      this.loading.table = true

      const params = {
        limit: this.limit,
        offset: this.offset,
        platform_name: this.platform,
        transaction_type: 'subscription',
        user_id: this.$route.params.id,
      }

      if (this.isGooglePlatform) {
        params.keyword = this.search
      } else {
        params.start_date = this.dateRange.startDate
          ? YEAR_MONTH_DAY(this.dateRange.startDate)
          : null
        params.end_date = this.dateRange.endDate
          ? YEAR_MONTH_DAY(this.dateRange.endDate)
          : null
      }

      try {
        const { data } = await newAxiosIns.get(
          'komads/api/v1/admin/whitelist_accounts/transactions',
          { params },
        )
        const newData = data.data || []
        this.subscriptionData.push(...newData)
        this.offset += newData.length
        this.lastData = newData.length < this.limit
      } catch (error) {
        this.$toast_error({
          message: 'Gagal mengambil data subscription',
        })
      } finally {
        this.loading.table = false
      }
    },
  },
}
</script>
